
import CatalogSearchSection from "../../../common/catalog/CatalogSearchSection";

export default function SearchSection({ initQuery, onSearch }) {
	return (
		<CatalogSearchSection
			title="جستجو در کارگاه‌ها"
			placeholder="نام کارگاه"
			initQuery={initQuery}
			onSearch={onSearch}
		/>
	);
}
